import { UpdateVoucherForm } from './update-voucher-form'

export const UpdateVoucherModal = ({
  voucherId,
  onCloseModal,
}: {
  voucherId: number
  onCloseModal: () => void
}) => {
  return <UpdateVoucherForm voucherId={voucherId} onCloseModal={onCloseModal} />
}
